import React, {useEffect,useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Form, } from 'antd';
import InputField from '../../common/InputField'
import { emailValidation, nameValidation} from '../../../helper/FeildValidations'
import {updateSpaceOwnerDetails} from './CreateHostAction';
import { v4 as uuidv4 } from 'uuid';

const layout = {
    labelCol: {
      span: 8
    },
    wrapperCol: {
      span: 16
    }
};

const CreateHost = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const savingSucess = useSelector(state => state?.createHost?.hostDetails?.success);
    const [hostDetails, setDetails] = useState({
        "password": "millionspaces@2021",
        "hideFields":false,
        "username":``,
    });

    const onFinish = (values) => {
        dispatch(updateSpaceOwnerDetails({
            ...values,
            "username":hostDetails.username,
            "emailVerified": false,
            "provider": "local",
            "roles": [
                {
                    "id": "role.user.host"
                }
            ]
        }, 
        )); 
    }
    
    useEffect(() => {
        if(savingSucess){
            form.setFieldsValue({
                "firstName":'',
                "lastName":'',
                "email":''
            })
        }
       },[savingSucess]);       
    const createUsername = () => {
        let characters = uuidv4();
        setDetails({username:characters})
    }

    return (
        <Form
            {...layout}
            form={form}
            initialValues={hostDetails}
            onFinish={onFinish}
        >
            <h1 className="title">Create Host</h1>
            <div className="basic-details-wrapper">
                <>
        
                    <InputField
                        name={['firstName']}
                        label={'First Name'}
                        rules={nameValidation}
                    />
                    <InputField
                        name={['lastName']}
                        label={'Last Name'}
                        rules={nameValidation}
                    />
                    <InputField
                        name={['email']}
                        label={'Email Address'}
                        rules={emailValidation}
                        handleOnChange={createUsername}
                    />
                    <InputField 
                        name={['password']}
                        label={"Password"}
                        isDisabled = {true}
                    />
                    {hostDetails.hideFields &&
                <>
                    <InputField
                        name={['username']}
                        label={'Username'}
                        isDisabled={true}
                    />
                    <InputField
                        name={['emailVerified']}
                        label={"Email Verified"}
                        isDisabled={true}
                    />
                    <InputField
                        name={[ 'provider']}
                        label={"Provider"}
                        isDisabled={true}
                    />
                    <InputField
                        name={['roles']}
                        label={"Roles"}
                        isDisabled={true}
                    />
                 </>}
                    <div className="btn-wrapper"> 
                        <Button 
                            className="submit-btn" 
                            type="primary" 
                            htmlType="submit" 
                        >Submit</Button> 
                    </div>
                </>
            </div>
        </Form>
    )
}

export default CreateHost;